import ToggleWithConfirm from './ToggleWithConfirm'
import './styles.css'

export default ToggleWithConfirm
